import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import CustomerHistory from "../components/customers/customerHistory/customerHistory";
import CustomerScreen from "../components/customers/customerScreen";
import AddEditCustomerScreen from "../components/customers/addEditCustomerScreen";
import PrintMembershipCard from "../components/customers/printMembershipCard";
import PrintCustomer from "../components/customers/printCustomer";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const CustomerStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"CustomerScreen"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="CustomerScreen" component={CustomerScreen} />
            <AppStack.Screen name="AddEditCustomer" component={AddEditCustomerScreen} />
            <AppStack.Screen name="CustomerHistory" component={CustomerHistory} />
            <AppStack.Screen name="PrintMembershipCard" component={PrintMembershipCard} />
            <AppStack.Screen name="PrintCustomer" component={PrintCustomer} />
        </AppStack.Navigator>
    );
};

export default CustomerStack;